export const FETCH_APPLICATION_SETTINGS = 'FETCH_APPLICATION_SETTINGS';